/* CUSTOM_RFQ_BY_CLAUDE — Mobile tap haptics for header controls (Ryan 2026-07-11).
   Fires a 50ms vibration on tap of: the quote icon, the cart icon, the search toggle, the hamburger
   (3-lines) menu toggle, and any link/button inside the mobile menu that the hamburger opens.

   - Gated to small touch screens ((max-width:768px) and (pointer:coarse)) so the desktop — which reports
     touch/coarse on Ryan's laptop — never fires it (see the touchscreen-laptop rule).
   - iOS Safari has no Vibration API, so 'vibrate' in navigator is false there and this is a silent no-op;
     Android/Chrome is where it actually buzzes.
   - Delegated on document in the capture phase, so it still fires for controls that stop propagation and
     for menu links injected after load. A click (not pointerdown) is used so starting a scroll inside the
     menu doesn't misfire a buzz. */
(function () {
  if (!('vibrate' in navigator)) return;

  var mq = window.matchMedia('(max-width: 768px) and (pointer: coarse)');

  var SELECTOR = [
    '#quote-icon',                    /* quote drawer icon */
    '#cart-icon',                     /* cart drawer icon */
    '.header__icon.js-show-search',   /* search toggle (minimised mobile search) */
    '.header__icon--search-left',     /* alt search toggle */
    '.main-menu__toggle',             /* hamburger (3 lines) */
    '.main-menu__content a',          /* every link in the opened mobile menu */
    '.main-menu__content summary',    /* mega-nav expand toggles in the mobile menu */
    '.main-menu__content button'      /* any button (CTA etc.) in the mobile menu */
  ].join(',');

  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    if (!e.target.closest(SELECTOR)) return;
    navigator.vibrate(50);
  }, true);
})();
